<template>
    <div class="project-layout-container">
        <el-scrollbar wrap-class="scrollbar-wrapper" v-if="projectTelphoneList.includes(userInfo.telephone)">
            <el-menu :collapse-transition="false" unique-opened :default-active="activeRouter">
                <el-menu-item :index="item.name" :key="item.name" @click="gotoPage(item.name)" v-for="item in menus">
                    <i class="el-icon-menu"></i>
                    <span slot="title">{{ item.meta.title }}</span>
                </el-menu-item>
            </el-menu>
        </el-scrollbar>
        <router-view class="content1" :style="{ width: projectTelphoneList.includes(userInfo.telephone) ? 'calc(100% - 200px)' : '100%'}"></router-view>
    </div>
</template>

<script>
import routers from '@/router/routes.js';
import { mapState } from 'vuex';
import user from '../../store/modules/user';
export default {
    components: {},
    props: {},
    data() {
        return {
            menus:[],
            iconMap: {
                
            },
            projectTelphoneList: JSON.parse(localStorage.getItem("projectTelphoneList")) || [],
            userInfo: JSON.parse(localStorage.getItem("data")).data.user || [],
        };
    },
    watch: {},
    computed: {
        activeRouter(){
            return this.$route.name
        },
    },
    
    created() {
        this.menus = routers.find(item => item.name === 'project').children;
        
    },
    mounted() {
        
    },
    methods: {
        gotoPage(name) {
            this.$router.push({name: name})
        },
    },
};
</script>
<style lang="scss" scoped>
.el-menu {
    background-color: #061f3e;
    min-height: 100vh;
}
.el-menu-item {
    color: #fff;
}
.el-menu-item.is-active {
    background-color: #409eff;
}
.el-menu-item:hover {
    background-color: #409eff;
}
.project-layout-container{
    display: flex;
    min-height: 100vh;
    .content1{
        width: calc(100% - 200px);
        padding: 10px;
        box-sizing: border-box;
    }
}
.el-scrollbar{
    height: 100vh;
    width: 200px;
}
/deep/ .scrollbar-wrapper {
    height: 100vh;
    overflow-x: hidden !important;
    overflow-y: auto;
    margin-bottom: 0 !important;
}
</style>